export class DeleteRecordsVolumeBySectorUseCase {
  constructor(repository) {
    this.repository=repository
  }
  async execute(FK_SECTOR) {
    const hasRegisters=await this.repository.checkIfEmpty(FK_SECTOR)

    if(hasRegisters){
      return await this.repository.del(FK_SECTOR)
    }

    return
  }
}
